import { StyledAvatar } from './Avatar.styles';

export default StyledAvatar;
